import React from "react";
import { useHistory } from "react-router-dom";
import { Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";

const PHONE = "+917293838383";
const EMAIL = "support@masterclick.in";
const WA_LINK = "https://wa.me/917293838383?text=Hello%2C%20I%20need%20support";
const YT_LINK = "https://www.youtube.com/@masterclick";
const FB_LINK = "https://www.facebook.com/masterclick";
const IG_LINK = "https://www.instagram.com/masterclick";

const SocialBtn = ({ bg, href, label, children }) => (
  <a href={href} target="_blank" rel="noreferrer" style={{ textDecoration: "none", flex: 1 }}>
    <div style={{
      background: bg,
      borderRadius: 16,
      padding: "14px 10px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 6,
      boxShadow: "0 2px 10px rgba(0,0,0,0.10)",
    }}>
      {children}
      <span style={{ fontSize: 11, fontWeight: 700, color: "#fff", letterSpacing: 0.3 }}>{label}</span>
    </div>
  </a>
);

const ContactRow = ({ icon, label, sub, href, iconBg, iconColor }) => (
  <a href={href} style={{ textDecoration: "none" }}>
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: 14,
      background: "#fff",
      borderRadius: 16,
      padding: "14px 18px",
      marginBottom: 10,
      boxShadow: "0 2px 10px rgba(14,58,83,0.07)",
      cursor: "pointer",
    }}>
      <div style={{
        width: 44, height: 44, borderRadius: 14,
        background: iconBg,
        display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0,
      }}>
        {React.cloneElement(icon, { sx: { fontSize: 22, color: iconColor } })}
      </div>
      <div style={{ flex: 1 }}>
        <Typography style={{ fontSize: 14, fontWeight: 700, color: "#1a2e3b", lineHeight: 1.2 }}>{label}</Typography>
        <Typography style={{ fontSize: 12, color: "#9ab0be", marginTop: 2 }}>{sub}</Typography>
      </div>
      <div style={{
        background: iconBg, borderRadius: 10,
        padding: "5px 12px",
        fontSize: 11, fontWeight: 700, color: iconColor,
      }}>
        Tap
      </div>
    </div>
  </a>
);

const HelpSupport = () => {
  const history = useHistory();

  return (
    <div style={{ minHeight: "100vh", background: "#f4f6fb", paddingBottom: 40 }}>

      {/* Top bar */}
      <div style={{
        background: "linear-gradient(135deg,#0E3A53,#1a6b8a)",
        padding: "16px 16px 40px",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
          <ArrowBackIcon
            onClick={() => history.push("/my-profile")}
            sx={{ color: "#fff", cursor: "pointer", fontSize: 22 }}
          />
          <Typography style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>
            Help & Support
          </Typography>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{
            width: 60, height: 60, borderRadius: "50%",
            background: "rgba(255,255,255,0.15)",
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 10px",
          }}>
            <HeadsetMicOutlinedIcon sx={{ fontSize: 30, color: "#fff" }} />
          </div>
          <Typography style={{ fontSize: 16, fontWeight: 700, color: "#fff" }}>
            MasterClick Support
          </Typography>
          <Typography style={{ fontSize: 12, color: "rgba(255,255,255,0.72)", marginTop: 4 }}>
            We're here to help you 24/7
          </Typography>
        </div>
      </div>

      <div style={{ padding: "0 16px", marginTop: -20 }}>

        {/* Contact card */}
        <div style={{
          background: "#fff",
          borderRadius: 20,
          padding: "18px 16px",
          boxShadow: "0 4px 20px rgba(14,58,83,0.10)",
          marginBottom: 14,
        }}>
          <Typography style={{ fontSize: 11, fontWeight: 800, color: "#9ab0be", letterSpacing: 1.2, textTransform: "uppercase", marginBottom: 14 }}>
            Contact Support
          </Typography>

          <ContactRow
            icon={<PhoneOutlinedIcon />}
            label="Call Support"
            sub={PHONE}
            href={`tel:${PHONE}`}
            iconBg="#e8f4f8"
            iconColor="#2182B1"
          />
          <ContactRow
            icon={<WhatsAppIcon />}
            label="WhatsApp Support"
            sub="Chat with us on WhatsApp"
            href={WA_LINK}
            iconBg="#e8fdf2"
            iconColor="#25d366"
          />
          <ContactRow
            icon={<EmailOutlinedIcon />}
            label="Email Support"
            sub={EMAIL}
            href={`mailto:${EMAIL}`}
            iconBg="#fef9ec"
            iconColor="#f59e0b"
          />
        </div>

        {/* Social links card */}
        <div style={{
          background: "#fff",
          borderRadius: 20,
          padding: "18px 16px",
          boxShadow: "0 4px 20px rgba(14,58,83,0.10)",
          marginBottom: 14,
        }}>
          <Typography style={{ fontSize: 11, fontWeight: 800, color: "#9ab0be", letterSpacing: 1.2, textTransform: "uppercase", marginBottom: 14 }}>
            Follow Us
          </Typography>
          <div style={{ display: "flex", gap: 10 }}>
            <SocialBtn bg="#ff0000" href={YT_LINK} label="YouTube">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="#fff">
                <path d="M21.8 8s-.2-1.4-.8-2c-.8-.8-1.6-.8-2-.9C16.8 5 12 5 12 5s-4.8 0-7 .1c-.4.1-1.2.1-2 .9-.6.6-.8 2-.8 2S2 9.6 2 11.2v1.5c0 1.6.2 3.2.2 3.2s.2 1.4.8 2c.8.8 1.8.8 2.3.9C6.8 19 12 19 12 19s4.8 0 7-.1c.4-.1 1.2-.1 2-.9.6-.6.8-2 .8-2s.2-1.6.2-3.2v-1.5C22 9.6 21.8 8 21.8 8zM10 15V9l5.5 3L10 15z"/>
              </svg>
            </SocialBtn>
            <SocialBtn bg="#1877f2" href={FB_LINK} label="Facebook">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="#fff">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
              </svg>
            </SocialBtn>
            <SocialBtn bg="linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)" href={IG_LINK} label="Instagram">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="#fff">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="none" stroke="#fff" strokeWidth="2"/>
                <circle cx="12" cy="12" r="4" fill="none" stroke="#fff" strokeWidth="2"/>
                <circle cx="17.5" cy="6.5" r="1.5" fill="#fff"/>
              </svg>
            </SocialBtn>
          </div>
        </div>

        {/* Info card */}
        <div style={{
          background: "linear-gradient(135deg,#e8f4fd,#d6edf8)",
          border: "1.5px solid #b8d9ee",
          borderRadius: 18,
          padding: "14px 16px",
          display: "flex",
          alignItems: "center",
          gap: 12,
        }}>
          <HeadsetMicOutlinedIcon sx={{ fontSize: 22, color: "#2182B1", flexShrink: 0 }} />
          <Typography style={{ fontSize: 12.5, color: "#1a4a6b", lineHeight: 1.6, fontWeight: 500 }}>
            Our support team is available Monday to Saturday, 9 AM – 6 PM. For urgent issues, use WhatsApp for faster response.
          </Typography>
        </div>

      </div>
    </div>
  );
};

export default HelpSupport;
